import React from "react";
import PropTypes from "prop-types";
import _snakeCase from "lodash/snakeCase";
import { Tabs, Col, Icon, Tooltip } from "antd";
import { PermissionContextConsumer } from "hocs";
import CaseSummaryTab from "./case-summary-tab";
import CaseBureauDetails from "./case-bureau-details";
import CreditAppraisalTab from "./credit-appraisal-tab";
// import PreSanctionDocumentTab from "./pre-sanction-document-tab";
import DocumentsTab from "./documents-tab";
// import CreditSummary from "./credit-summary";
import AssessmentReviewReport from "./AssessmentReviewReport";
import DbView from "./db-view";
import CamView from "./cam-view";
import CamViewNew from "./cam-view-new";
import ScoreCard from "./score-card";
import FinancialAnalysisTab from "./financial-analysis-tab";
import FinalCreditSummary from "./final-credit-summary";
import MISReport from "./../case-task-notes-v2";
import PostSanctionDocumentsTab from "./post-sanction-documents-tab";
import AccountFacilityTab from "./account-facility-tab";
import WelcomeCallQuestionareTab from "./welcome-questionare-tab";
import AccountViewDetails from "./account-view";
import PreviousCasesList from "./previous-cases-list";
import DocumentReviewTab from "./document-review-tab";
import Agreement from "./agreement";
import RetailerRiskControl from "./retailer-risk-control";
import AdhocEnhancementTab from "./adhoc-enhancement-tab";
import CaseDocumentChecklist from "./case-document-checklist";
import CamEngineTab from "./cam-engine";
import NachMandate from "./nach-mandate";
import documentReviewTabV2 from "./document-review-tab-v2";
// import AmendmentTab from "./amendment-tab";
const TabPane = Tabs.TabPane;

let caseDetailsTabsArray = [
    {
        id: 1,
        tabName: "Adhoc/Enhancement",
        content: AdhocEnhancementTab,
        permission: "page_adhoc_enhancement"
    },
    {
        id: 2,
        tabName: "Credit Summary",
        content: FinalCreditSummary,
        permission: "page_credit_summary"
    },
    {
        id: 3,
        tabName: "Doc Checklist",
        content: CaseDocumentChecklist,
        permission: "page_case_details"
    },
    {
        id: 4,
        tabName: "FI / Bank BRE",
        content: AssessmentReviewReport,
        permission: "page_assessment_report"
    },
    {
        id: 5,
        tabName: "Seller View",
        content: DbView,
        permission: "db_pre_data_view"
    },
    {
        id: 6,
        tabName: "CAM View",
        content: CamView,
        permission: "page_cam_engine_view"
    },
    {
        id: 7,
        tabName: "All Cases",
        content: PreviousCasesList,
        permission: "page_all_cases_view"
    },
    // {
    //     tabName: "Documents Review (New)",
    //     content: documentReviewTabV2,
    //     permission: "page_documents"
    // },
    {
        id: 8,
        tabName: "Documents Review",
        content: DocumentReviewTab,
        permission: "page_documents"
    },
    {
        id: 9,
        tabName: "Case Details",
        content: CaseSummaryTab,
        permission: "page_case_details"
    },
    {
        id: 10,
        tabName: "Bureau Details",
        content: CaseBureauDetails,
        permission: "page_case_bureau_details_tab"
    },
    {
        id: 11,
        tabName: "Documents",
        content: DocumentsTab,
        permission: "page_documents"
    },
    {
        id: 12,
        tabName: "MIS",
        content: MISReport,
        permission: "page_mis"
    },
    {
        id: 13,
        tabName: "Post Sanction Documents",
        content: PostSanctionDocumentsTab,
        permission: "page_post_sanction_documentation"
    },
    {
        id: 14,
        tabName: "Credit Appraisal",
        content: CreditAppraisalTab,
        permission: "page_credit_appraisal"
    },

    {
        id: 15,
        tabName: "NACH Mandate",
        content: NachMandate,
        permission: "nach_assign"
    },

    // {
    //     tabName: "CAM Engine",
    //     content: CamEngineTab,
    //     permission: "page_cam_engine_view"
    // },
    {
        id: 16,
        tabName: "Financial Analysis",
        content: FinancialAnalysisTab,
        permission: "page_financial_analysis"
    },
    {
        id: 17,
        tabName: "Score Card",
        content: ScoreCard,
        permission: "page_scorecard"
    },
    {
        id: 18,
        tabName: "Account/Facility Details",
        content: AccountFacilityTab,
        permission: "page_account_facility_tab"
    },
    {
        id: 19,
        tabName: "PD Questionnaire",
        content: WelcomeCallQuestionareTab,
        permission: "page_account_welcome_questionnaire_tab"
    },
    {
        id: 20,
        tabName: "Account View",
        content: AccountViewDetails,
        permission: "page_account_view_tab"
    },
    {
        id: 21,
        tabName: "Agreement",
        content: Agreement,
        permission: "page_leegality_agreement"
    },
    {
        id: 22,
        tabName: "Risk Controls",
        content: RetailerRiskControl,
        permission: "page_credit_appraisal"
    },
    {
        id: 23,
        tabName: "Cam View (New)",
        content: CamViewNew,
        permission: "page_cam_engine_view"
    },
];

let creditAppraisalTabSequence = [2, 6, 14, 16, 11, 7, 9, 19, 5, 10, 4, 17, 8, 18, 20, 1, 12, 15, 22, 23] 


class CaseDetailsTabs extends React.Component {
    state={
        overdueCaseIds:[]
    }
    default_caseDetailsTabsArray = [
        {
            id: 1,
            tabName: "Adhoc/Enhancement",
            content: AdhocEnhancementTab,
            permission: "page_adhoc_enhancement"
        },
        {
            id: 2,
            tabName: "Credit Summary",
            content: FinalCreditSummary,
            permission: "page_credit_summary"
        },
        {
            id: 3,
            tabName: "Doc Checklist",
            content: CaseDocumentChecklist,
            permission: "page_case_details"
        },
        {
            id: 4,
            tabName: "FI / Bank BRE",
            content: AssessmentReviewReport,
            permission: "page_assessment_report"
        },
        {
            id: 5,
            tabName: "Seller View",
            content: DbView,
            permission: "db_pre_data_view"
        },
        {
            id: 6,
            tabName: "CAM View",
            content: CamView,
            permission: "page_cam_engine_view"
        },
        {
            id: 7,
            tabName: "All Cases",
            content: PreviousCasesList,
            permission: "page_all_cases_view"
        },
        // {
        //     tabName: "Documents Review (New)",
        //     content: documentReviewTabV2,
        //     permission: "page_documents"
        // },
        {
            id: 8,
            tabName: "Documents Review",
            content: DocumentReviewTab,
            permission: "page_documents"
        },
        {
            id: 9,
            tabName: "Case Details",
            content: CaseSummaryTab,
            permission: "page_case_details"
        },
        {
            id: 10,
            tabName: "Bureau Details",
            content: CaseBureauDetails,
            permission: "page_case_bureau_details_tab"
        },
        {
            id: 11,
            tabName: "Documents",
            content: DocumentsTab,
            permission: "page_documents"
        },
        {
            id: 12,
            tabName: "MIS",
            content: MISReport,
            permission: "page_mis"
        },
        {
            id: 13,
            tabName: "Post Sanction Documents",
            content: PostSanctionDocumentsTab,
            permission: "page_post_sanction_documentation"
        },
        {
            id: 14,
            tabName: "Credit Appraisal",
            content: CreditAppraisalTab,
            permission: "page_credit_appraisal"
        },
    
        {
            id: 15,
            tabName: "NACH Mandate",
            content: NachMandate,
            permission: "nach_assign"
        },
    
        // {
        //     tabName: "CAM Engine",
        //     content: CamEngineTab,
        //     permission: "page_cam_engine_view"
        // },
        {
            id: 16,
            tabName: "Financial Analysis",
            content: FinancialAnalysisTab,
            permission: "page_financial_analysis"
        },
        {
            id: 17,
            tabName: "Score Card",
            content: ScoreCard,
            permission: "page_scorecard"
        },
        {
            id: 18,
            tabName: "Account/Facility Details",
            content: AccountFacilityTab,
            permission: "page_account_facility_tab"
        },
        {
            id: 19,
            tabName: "PD Questionnaire",
            content: WelcomeCallQuestionareTab,
            permission: "page_account_welcome_questionnaire_tab"
        },
        {
            id: 20,
            tabName: "Account View",
            content: AccountViewDetails,
            permission: "page_account_view_tab"
        },
        {
            id: 21,
            tabName: "Agreement",
            content: Agreement,
            permission: "page_leegality_agreement"
        },
        {
            id: 22,
            tabName: "Risk Controls",
            content: RetailerRiskControl,
            permission: "page_credit_appraisal"
        },
        {
            id: 23,
            tabName: "Cam View (New)",
            content: CamViewNew,
            permission: "page_cam_engine_view"
        },
    ];
    getContentProps = tabName => {
        const {
            user,
            caseId,
            companyId,
            caseDetail,
            supplyChainDetail,
            caseSanction,
            caseTaskId,
            stageId,
            stageName,
            getActionModal,
            openDocView,
            location,
            match,
            companyName,
            isUserAllowedToEdit,
            company,
            caseAssociatesStatus,
            caseAssociates,
            dbViewTableData,
            anchorViewTableData,
            geoViewTableData,
            stateViewTableData,
            all_enums,
            camEngineData,
            camEngineStatus,
            fetchCamEngineView,
            fetchCamEngineViewComments,
            camEngineCommentsData,
            camEngineCommentsStatus,
            fetchCaseDetail,
            postSanctionPermission,
            fetchCamEngineStatusLogs,
            camEngineStatusLogsData,
            camEngineStatusLogsStatus
        } = this.props;
        const schemeType = this.props.caseDetail?.scheme_type;
        const isRiskApprover = this.props.isRiskApprover;
        switch (tabName) {
        case "Amendment":
            return {
                caseDetail,
                caseTaskId,
                caseId,
                companyId,
                isUserAllowedToEdit
            };
        case "Adhoc/Enhancement":
            return {
                caseDetail,
                caseTaskId,
                caseId,
                companyId,
                isUserAllowedToEdit,
                stageId,
                stageName
            };
        case "Case Details":
            return { caseDetail,caseTaskId, caseId, companyId, isUserAllowedToEdit, caseAssociatesStatus, caseAssociates };
        case "Bureau Details":
            return { caseId, companyId };
        case "Seller View":
            return {dbViewTableData,  stateViewTableData, caseDetail, all_enums, caseId};
        case "CAM View":
            return {camEngineData, camEngineStatus, fetchCamEngineView, fetchCaseDetail, user, stageId, fetchCamEngineStatusLogs, camEngineStatusLogsData, camEngineStatusLogsStatus};
        case "Cam View (New)":
            return {camEngineData, camEngineStatus, fetchCamEngineView, fetchCaseDetail, fetchCamEngineViewComments, camEngineCommentsData, camEngineCommentsStatus, user};
        case "Credit Appraisal":
            return {
                caseDetail,
                supplyChainDetail,
                companyId,
                caseId,
                onTabChange: this.onTabChange,
                isRiskApprover,
                isUserAllowedToEdit,
                caseAssociatesStatus,
                caseAssociates,
                stageId
            };
        case "FI / Bank BRE":
            return {
                caseDetail,
                caseId,
                companyId,
                isUserAllowedToEdit
            };
        case "Sanction Details":
            return { caseSanction, isUserAllowedToEdit };
        case "Documents":
            return {
                caseId,
                location,
                companyId,
                isRiskApprover,
                documentsType: "pre-sanction",
                isUserAllowedToEdit,
                caseAssociatesStatus,
                caseAssociates
            };
        case "Documents Review":
            return {
                caseId,
                location,
                companyId,
                isRiskApprover,
                documentsType: "pre-sanction",
                isUserAllowedToEdit,
                stageId
            };
        // case "Documents Review (New)":
        //     return {
        //         caseId,
        //         location,
        //         companyId,
        //         isRiskApprover,
        //         documentsType: "pre-sanction",
        //         isUserAllowedToEdit,
        //         stageId
        //     };
        case "MIS":
            return {
                caseId,
                stageId
            };
        case "Post Sanction Documents":
            return {
                caseId,
                location,
                companyId,
                isRiskApprover,
                documentsType: "post-sanction",
                isUserAllowedToEdit
            };    
        case "Score Card":
            return { caseId, isRiskApprover, isUserAllowedToEdit, companyId };
        case "Credit Summary":
            return {
                companyId,
                caseId,
                caseDetail,
                supplyChainDetail,
                caseTaskId,
                stageId,
                stageName,
                getActionModal,
                openDocView,
                isRiskApprover,
                location,
                match,
                companyName,
                caseAssociatesStatus,
                caseAssociates,
                isUserAllowedToEdit,
                camEngineData,
                camEngineStatus,
                fetchCamEngineView, 
                fetchCaseDetail
            };
        case "Financial Analysis":
            return {
                companyId,
                caseId,
                caseDetail,
                isRiskApprover,
                isUserAllowedToEdit
            };
        case "Account/Facility Details":
            return {
                caseDetail,
                companyId,
                isUserAllowedToEdit,
                location,
                companyName,
                stageName,
                stageId,
                caseId,
            };
        case "PD Questionnaire":
            return {
                companyId,
                isUserAllowedToEdit,
                location,
                companyName,
                stageName,
                stageId,
                caseId,
                caseDetail,
                caseData: {
                    company: company && company.name,
                    sellers: caseDetail.sellersName,
                    anchors: caseDetail.anchors,
                    tenor: caseDetail.tenure,
                    proposed_limit: caseDetail.proposed_limit,
                    bankCode: caseDetail.getBankCode()
                }
            };
        case "Account View":
            return {
                companyId,
                caseId,
                location,
                companyName,
                stageName,
                stageId,
                isUserAllowedToEdit
            };
        case "All Cases":
            return {
                company,
                caseId,
                location,
                caseDetail
            };
        case "Agreement":
            return {
                caseId,
                location,
                stageId,
                caseDetail,
                company,
                user,
                postSanctionPermission
            };
        case "Risk Controls":
            return {
                caseId,
                companyId,
                location,
                stageId,
                caseDetail,
                company,
                user,
                postSanctionPermission
            };
        case "Doc Checklist":
            return {
                caseId,
                companyId,
                openAsTab: true
            };
        case "NACH Mandate": 
            return {
                caseId,
                companyId,
                schemeType
            }
        default:
            return {
                isUserAllowedToEdit,
                caseAssociatesStatus,
                caseAssociates
            };
        }
    };
    onTabChange = tabName => {
        const { pageID, caseId } = this.props.match.params;
        this.props.history.replace(
            `/app/${pageID}/${caseId}/${_snakeCase(tabName)}`,
            {
                ...this.props.location.state,
                tabId: _snakeCase(tabName)
            }
        );
    };
    componentDidMount(){
        if(this.props.stageId == 7){
            caseDetailsTabsArray = caseDetailsTabsArray.sort((a, b) => 
                creditAppraisalTabSequence.indexOf(a.id) - creditAppraisalTabSequence.indexOf(b.id)
            );
            caseDetailsTabsArray = caseDetailsTabsArray.filter(tab => 
                creditAppraisalTabSequence.includes(tab.id)
            );
        }else{
            caseDetailsTabsArray = this.default_caseDetailsTabsArray;
        }
    }
    getActiveTab(tab, context) {
        let isTabExisted = caseDetailsTabsArray.find(_ => !_.permission || context.get(_.permission) && _snakeCase(_.tabName)  === tab);
        if(isTabExisted) {
            return isTabExisted.tabName;
        } 
        return (caseDetailsTabsArray.filter(_ => context.get(_.permission))[0] || {}).tabName;
    }
    overdueDataFn = (data) => {
        let overdueData = data && Object.values(data).filter(el=>el.dpd_dd_value_0_30.value >0 || el.dpd_dd_value_31_60.value >0 || el.dpd_dd_value_61_90.value >0 || el.dpd_dd_value_91_9999.value >0).map(el=>el.caseId.value.split("-")[1]);
        this.setState({overdueCaseIds:[...overdueData]});
        this.props.history.push({
            state: {...this.props.history.location.state , overdueCaseIds:[...overdueData]}
        });
    }
    render() {
        const { tab } = this.props;
        // if(this.props.stageId && this.props.stageId !== 17) {
        //     caseDetailsTabsArray = caseDetailsTabsArray.filter(_ => _.tabName !== "Account View");
        // }
        if(this.props.stageId && this.props.stageId === 2) {
            caseDetailsTabsArray = caseDetailsTabsArray.filter(_ => _.tabName === "Adhoc/Enhancement");
        }
        if(this.props.stageId && this.props.stageId !== 2){
            caseDetailsTabsArray = caseDetailsTabsArray.filter(_ => _.tabName !== "Adhoc/Enhancement");
        }
        if(!(this.props.stageId && [57,14,35,24,13,17,11].includes(this.props.stageId) && ['Default Scheme' , "Term Loan"].includes(this.props.caseDetail?.scheme_type))) {
            caseDetailsTabsArray = caseDetailsTabsArray.filter(_ => _.tabName !== "NACH Mandate");
        }
        if(this.props.caseId == 130090){
            caseDetailsTabsArray = caseDetailsTabsArray.filter(_ => !["Seller View", "FI / Bank BRE", "All Cases", "Post Sanction Documents", "Score Card", "Risk Controls" , "Cam View (New)"].includes(_.tabName));
        }
        if(this.props.caseId == 141834){
            caseDetailsTabsArray = caseDetailsTabsArray.filter(_ => !["FI / Bank BRE", "Score Card","All Cases", "Post Sanction Documents", "Risk Controls", "Cam View (New)"].includes(_.tabName));
        }
        return (
            <PermissionContextConsumer>
                {context => {
                    const activeTab = caseDetailsTabsArray.find(_ => (_.tabName === this.getActiveTab(tab, context) && (!_.permission ||context.get(_.permission))));
                    return (
                        <React.Fragment>
                            <Col span={24} className={"case-detail-tabs"}>
                                <Tabs
                                    animated={false}
                                    onChange={this.onTabChange}
                                    activeKey={this.getActiveTab(tab, context)}
                                >
                                    {caseDetailsTabsArray
                                        .filter(_ => (!_.permission || context.get(_.permission)))
                                        .map(_ => {
                                            return(
                                                <TabPane key={_.tabName} tab={_.tabName === "All Cases" ? 
                                                    <span>
                                                        {_.tabName}
                                                        {this.state.overdueCaseIds.length >0 && (this.props.stageName === "Credit Appraisal" || this.props.stageName === "Progcap Credit") && <Tooltip title={"Overdue"}>
                                                            <Icon key={"overdue_icon"} style={{ margin:"0 8px",
                                                                fontSize: "14px", color:"red"
                                                            }} type={"info-circle"} />
                                                        </Tooltip>}
                                                    </span>
                                                    : _.tabName }/>
                                            );})}
                                </Tabs>   
                            </Col>     
                            <Col span={24}>
                                <activeTab.content
                                    {...this.getContentProps(activeTab.tabName)}
                                    permissionContext={context}
                                    caseId={this.props.caseId}
                                    overdueData={this.overdueDataFn}
                                    recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                                />     
                            </Col> 
                        </React.Fragment>
                    );
                }}
            </PermissionContextConsumer>
        );
    }
}

CaseDetailsTabs.propTypes = {
    closeDrawer: PropTypes.func,
    caseDetail: PropTypes.object,
    supplyChainDetail: PropTypes.object,
    caseSanction: PropTypes.any,
    toggleExpand: PropTypes.func,
    companyId: PropTypes.number,
    isAnchor: PropTypes.bool,
    caseId: PropTypes.number,
    tab: PropTypes.string,
    history: PropTypes.object,
    location: PropTypes.object,
    match: PropTypes.object,
    stageId: PropTypes.number,
    stageName: PropTypes.string,
    caseTaskId: PropTypes.number,
    openDocView: PropTypes.func,
    getActionModal: PropTypes.func,
    viewCaseNotes: PropTypes.func,
    isRiskApprover: PropTypes.bool,
    companyName: PropTypes.string,
    isUserAllowedToEdit: PropTypes.bool,
    isDisbursedStage: PropTypes.bool,
    recreditViewOnlyPermission: PropTypes.bool,
    company: PropTypes.object,
    caseAssociatesStatus: PropTypes.string,
    caseAssociates: PropTypes.array,
    dbViewTableData: PropTypes.array,
    anchorViewTableData: PropTypes.array,
    geoViewTableData: PropTypes.array,
    stateViewTableData: PropTypes.array,
    user : PropTypes.number,
    postSanctionPermission: PropTypes.bool
};

export default CaseDetailsTabs;
